import { Modal, Spin } from 'antd';
import React from 'react';

import s from './PageLoader.module.less';

interface Props {
  title: string;
  isVisible: boolean;
}

const PageLoader: React.FC<Props> = ({ title, isVisible }) => (
  <Modal
    className={s.root}
    centered
    keyboard={false}
    closable={false}
    destroyOnHidden
    mask={{ closable: false }}
    open={isVisible}
    footer={null}
  >
    <Spin spinning size="large" tip={title} />
  </Modal>
);

export default PageLoader;
